/* eslint-disable react/prop-types */
import React from 'react';
import { NavigationIcon } from "./NavigationIcon";
import { PageNavigationGroup } from "./PageNavigationGroup";
import SkipBackIcon from "../../icons/ArrowDoubleLeft";
import StepBackIcon from "../../icons/ArrowChevronLeft";
import StepForwardsIcon from "../../icons/ArrowChevronRight";
import SkipForwardsIcon from "../../icons/ArrowDoubleRight";
import { _PaginationSpan } from "./styles";
export function PageNavigation(props) {
  var currentPage = props.currentPage,
    lastPage = props.lastPage,
    goToPage = props.goToPage,
    hidePageNavigationGroup = props.hidePageNavigationGroup,
    hideSkipButtons = props.hideSkipButtons;

  // rendered below as components
  var SkipBack = function SkipBack() {
    return /*#__PURE__*/React.createElement(NavigationIcon, {
      Icon: SkipBackIcon,
      targetPage: 1,
      goToPage: goToPage
    });
  };
  var SkipForwards = function SkipForwards() {
    return /*#__PURE__*/React.createElement(NavigationIcon, {
      Icon: SkipForwardsIcon,
      targetPage: lastPage,
      goToPage: goToPage
    });
  };
  var StepBack = function StepBack() {
    return /*#__PURE__*/React.createElement(NavigationIcon, {
      Icon: StepBackIcon,
      targetPage: currentPage === 1 ? 1 : currentPage - 1,
      goToPage: goToPage
    });
  };
  var StepForwards = function StepForwards() {
    return /*#__PURE__*/React.createElement(NavigationIcon, {
      Icon: StepForwardsIcon,
      targetPage: currentPage === lastPage ? lastPage : currentPage + 1,
      goToPage: goToPage
    });
  };
  return /*#__PURE__*/React.createElement(_PaginationSpan, null, !hideSkipButtons && /*#__PURE__*/React.createElement(SkipBack, null), /*#__PURE__*/React.createElement(StepBack, null), !hidePageNavigationGroup && /*#__PURE__*/React.createElement(PageNavigationGroup, props), /*#__PURE__*/React.createElement(StepForwards, null), !hideSkipButtons && /*#__PURE__*/React.createElement(SkipForwards, null));
}